import styled from "styled-components";

export const ToolsFrame = styled.iframe`
  width: 100%;
  min-height: calc(100vh - 72px);
`;
